import { Tabs } from 'antd';
import './styles.css';
interface IPaginationTabHeaderProps {
    tabs: any;
    setPag: (page: number) => void;
    pag: any;
    setKey: (key: number) => void;
    keyDefault: any;
}
const PaginationTabHeader = ({ tabs, setPag, pag, setKey, keyDefault }: IPaginationTabHeaderProps) => {
    const handleTabChange = (activeKey: string) => {
        const index = Number(activeKey);
        setPag(index);
        setKey(keyDefault + 1);
    };
    return (
        <Tabs
            activeKey={pag.toString()}
            onChange={handleTabChange}
            type="card"
            className="pagination-tabs-header"
        >
            {tabs.map((tab: any, index: any) => (
                <Tabs.TabPane
                    tab={tab}
                    key={index.toString()}
                    className={pag === index ? 'tab-selected' : ''}
                />
            ))}
        </Tabs>
    );
};
export default PaginationTabHeader;